import { ReactNode, ElementType } from 'react';
export interface NextgenImageProviderInterface {
  element: ElementType;
  children: ReactNode;
  useCDNForCS?: boolean;
}

export enum LoaderType {
  CONTENTSTACK = 'CONTENTSTACK',
  WEBFONTS = 'WEBFONTS',
}

export type OnLoadingComplete = (img: HTMLImageElement) => void;
export type PlaceholderValue = 'blur' | 'empty' | `data:image/${string}`;

export type ImageLoaderProps = {
  src: string;
  width: number;
  quality?: number;
};

export interface StaticImageData {
  src: string;
  height: number;
  width: number;
  blurDataURL?: string;
  blurWidth?: number;
  blurHeight?: number;
}
export interface StaticRequire {
  default: StaticImageData;
}
export type StaticImport = StaticRequire | StaticImageData;

export type ImageLoader = (p: ImageLoaderProps) => string;

export type BasicImageTypes = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;
export interface NextgenImagePropsBase extends Omit<BasicImageTypes, 'alt' | 'src' | 'ref'> {
  src: string | StaticImport;
  alt: string;
  width?: number | `${number}` | undefined;
  height?: number | `${number}` | undefined;
  fill?: boolean | undefined;
  loader?: ImageLoader | undefined;
  quality?: number | `${number}` | undefined;
  priority?: boolean | undefined;
  loading?: 'eager' | 'lazy' | undefined;
  placeholder?: PlaceholderValue | undefined;
  blurDataURL?: string | undefined;
  unoptimized?: boolean | undefined;
  onLoadingComplete?: OnLoadingComplete | undefined;
  layout?: string | undefined;
  objectFit?: string | undefined;
  objectPosition?: string | undefined;
  lazyBoundary?: string | undefined;
  lazyRoot?: string | undefined;

  loaderType?: LoaderType;
  isRelativeURL?: boolean;
  fallbackQuality?: number;
  format?: string;
}

export interface NextgenImagePropsWithRef extends NextgenImagePropsBase, React.RefAttributes<HTMLImageElement | null> {}

export type NextgenImageProps = NextgenImagePropsWithRef;

export type ForwardRefComponent<P> = React.ForwardRefExoticComponent<P & React.RefAttributes<unknown>>;
